import "./style.css";


export default class LatestPublications {

}
